<div class="rest-api-connector">

  <!-- Endpoint + Method -->
  <div style="display: flex; gap: 10px; align-items: center;">
    <mat-form-field appearance="outline" style="width: 150px;">
      <mat-label>Method</mat-label>
      <mat-select [(ngModel)]="viewModel.httpMethod">
        <mat-option *ngFor="let method of httpMethods" [value]="method">
          {{ method }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Endpoint URL</mat-label>
      <input matInput [(ngModel)]="viewModel.endpointUrl" placeholder="https://api.example.com/data">
    </mat-form-field>
  </div>

  <!-- Auth Type -->
  <div style="margin-top: 15px;">
    <mat-form-field appearance="outline" style="width: 200px;">
      <mat-label>Auth Type</mat-label>
      <mat-select [(ngModel)]="viewModel.authType">
        <mat-option value="none">No Auth</mat-option>
        <mat-option value="basic">Basic Auth</mat-option>
        <mat-option value="bearer">Bearer Token</mat-option>
        <mat-option value="apikey">API Key</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Basic Auth Fields -->
  <div *ngIf="viewModel.authType === 'basic'" style="display: flex; gap: 10px; margin-top: 10px;">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Username</mat-label>
      <input matInput [(ngModel)]="viewModel.userName" placeholder="Enter username">
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Password</mat-label>
      <input matInput type="password" [(ngModel)]="viewModel.password" placeholder="Enter password">
    </mat-form-field>
  </div>

  <!-- Bearer Token Field -->
  <div *ngIf="viewModel.authType === 'bearer'" style="margin-top: 10px;">
    <mat-form-field appearance="outline" style="flex: 1; width: 400px;">
      <mat-label>Bearer Token</mat-label>
      <input matInput [(ngModel)]="viewModel.bearerToken" placeholder="Enter token">
    </mat-form-field>
  </div>

  <!-- API Key Fields -->
  <div *ngIf="viewModel.authType === 'apikey'" style="display: flex; gap: 10px; margin-top: 10px; align-items: center;">
    <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Key</mat-label>
      <input matInput [(ngModel)]="viewModel.apiKey" placeholder="Enter API key">
    </mat-form-field>
     <mat-form-field appearance="outline" style="flex: 1;">
      <mat-label>Value</mat-label>
      <input matInput [(ngModel)]="viewModel.apiKey" placeholder="Enter API key">
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 150px;">
      <mat-label>Add To</mat-label>
      <mat-select [(ngModel)]="viewModel.apiKeyLocation">
        <mat-option value="header">Header</mat-option>
        <mat-option value="query">Query Param</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Send Button -->
  <div style="margin-top: 20px;">
    <button mat-raised-button color="primary" (click)="sendRequest()">
      Send
    </button>
  </div>

</div>
